import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const VintageError: FunctionComponent = () => {
  return (
    <Fragment>
      <Text className="error-description">Seems like your savings account with us is less than 12 months old. We will not be able to service you as of now.</Text>
      <Text className="error-description">Please visit your nearest Axis Bank branch to complete your remittance transaction.</Text>
    </Fragment>
  )
}

export default VintageError;
